import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  chipIcon: {
    paddingLeft: '6px',
    marginLeft: '4px',
    fontSize: '14px',
  },
  chipLabel: {
    textOverflow: 'initial',
  },
}))

const ChipComponent = ({ label, onClick, isSelected, icon }) => {
  const classes = useStyles()
  return (
    <Chip
      classes={{ label: classes.chipLabel }}
      label={label}
      aria-label={`${isSelected ? 'Selected:' : 'Not Selected:'} ${label}`}
      aria-live="polite"
      color="primary"
      onClick={() => onClick(label)}
      variant={isSelected ? 'default' : 'outlined'}
      icon={
        icon && (
          <FontAwesomeIcon
            className={classes.chipIcon}
            icon={icon}
          />
        )
      }
    />
  )
}

ChipComponent.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  icon: PropTypes.any,
}

export default ChipComponent
